import NfcCardHeader from './NfcCardHeader';

export default NfcCardHeader;
